export class MarketplaceCtrl {

    constructor({orderId, shop}) {
        this.orderId = orderId;
        this.shop = shop
    }

    /**
     * Ajoute un accessoire au panier
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param offerId id de l'offre
     * @return retourne une {Promise} pour l'ajout d'accessoire
     */
    async addAccessory(idSeo, offerId) {
        if (this.orderId == null) {
            return this.#initAccessoryCart(idSeo, offerId, this.shop)
                .then((response) => {
                    this.orderId = response.orderId
                    return this.#fetchCart(this.orderId).then((cart) => {
                        return { cartInfo: cart, cartUrl: response.tunnelUrl }
                    })
                })
        } else {
            return this.#addAccessoryInCart(idSeo, offerId, this.orderId)
                .then((response) => {
                    return { cartInfo: response.cartInfo, cartUrl: response.cartUrl }
                })
        }
    }

    async deleteAccessory(idSeo) {
        return this.#deleteCrossSellAccessory(idSeo, this.orderId)
            .then((response) => {
                return { cartInfo: response.cartInfo, cartUrl: response.cartUrl }
            });
    }

    /**
     * Initialise le cart marketplace
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param offerId id de l'offre
     * @param shop shop
     * @return retourne une {Promise} pour l'init card
     */
    #initAccessoryCart(idSeo, offerId, shop) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                offerId: offerId,
                shop: shop
            }
            $.ajax({
                method: "POST",
                xhrFields: {
                    withCredentials: true
                },
                url: "/api/mobile/order/marketplace",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    /**
     * Ajoute ou retire un accessoire sur un panier en session
     * @param idSeo id seo de l'accessoire à ajouter
     * @param offerId id de l'offre
     * @param orderId orderId du panier sur lequel ajouter l'accessoire
     * @return retourne une {Promise} pour la mise à jour de l'accessoire
     */
    #addAccessoryInCart(idSeo, offerId, orderId) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                offerId: offerId
            }
            $.ajax({
                method: "POST",
                xhrFields: {
                    withCredentials: true
                },
                url: `/api/mobile/orders/${orderId}/accessories`,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    /**
     * retire un accessoire x-sell ou bundle en session
     * @param idSeo id seo de l'accessoire à ajouter
     * @param orderId orderId du panier sur lequel supprimer l'accessoire
     * @return retourne une {Promise} pour la mise à jour de l'accessoire
     */
    #deleteCrossSellAccessory(idSeo, orderId) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                quantity: 0
            }
            $.ajax({
                method: "PUT",
                xhrFields: {
                    withCredentials: true
                },
                url: `/api/mobile/orders/${orderId}/accessories`,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    #fetchCart(orderId) {

        let url =  `/api/mobile/orders/${orderId}/cartinfo`

        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: url,
                contentType: "application/json",
            }).done(data => {
                resolve(data);
            }).fail(error => {
                reject(error);
            });
        });
    }
}
